import React from 'react';
import { CandidateHeaderBadge } from '../CandidateHeaderBadge';
import { appendRedirectUri } from '../../../../utils/url';
import { IconSpan } from '../../../../components/IconSpan';
import { ChipColor } from '../../../../components/Chip';

interface PropTypes {
  jobId: number;
  jobName: string;
}

export function CandidatePageHeaderJobInfo(props: PropTypes) {
  return (
    <CandidateHeaderBadge
      text={
        <a
          className='text-info'
          href={appendRedirectUri(`/jobs/${props.jobId}`)}
          data-analytics-id='application-detail-job-link'
        >
          <IconSpan
            icon={{ className: 'fs-4', name: 'bi-briefcase' }}
            spanText={props.jobName}
          />
        </a>
      }
      classNames='ms-2h'
      chipColor={ChipColor.White}
    />
  );
}
